import type { Clip } from './types'

export function aiReviewPriority(clip: Clip): { stars: number; reason: string } | null {
  const value = clip.review_priority
  if (!value || !Number.isInteger(value.stars) || value.stars < 1 || value.stars > 5 || typeof value.reason !== 'string' || !value.reason.trim() || value.reason.length > 1200) return null
  return { stars: value.stars, reason: value.reason.trim() }
}

export function reviewPriorityOrder(a: Clip, b: Clip): number {
  // A producer's saved rating supersedes the suggestion for this clip.
  const stars = (clip: Clip) => clip.editorial_plan?.rating ?? aiReviewPriority(clip)?.stars ?? 0
  return stars(b) - stars(a) || a.created_at.localeCompare(b.created_at) || a.id.localeCompare(b.id)
}
